import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { Container, Header, Segment, Button, Icon, Item, Grid, Divider, Form, Radio, Message, Image } from 'semantic-ui-react';
import { selectCartItems, selectCartTotal, removeFromCart, clearCart } from '../slices/cartSlice';
import infoTornado from '../assets/shutterstock_2294406661_circle.png';

import { AuthStdFooter } from "../utils/auth-std-footer";
const Checkout = () => {
  const cartItems = useSelector(selectCartItems);
  const cartTotal = useSelector(selectCartTotal);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [paymentMethod, setPaymentMethod] = React.useState('credit-card');
  const [checkoutComplete, setCheckoutComplete] = React.useState(false);

  const handlePaymentChange = (e, { value }) => setPaymentMethod(value);

  const handleRemoveItem = (voiceId) => {
    dispatch(removeFromCart(voiceId));
  };

  const handleCheckout = () => {
    // In a real application, this would process the payment
    // For now, we'll just show a success message and clear the cart
    setCheckoutComplete(true);
    setTimeout(() => {
      dispatch(clearCart());
      navigate('/dashBoard');
    }, 3000);
  };

  if (checkoutComplete) {
    return (
      <Container style={{ marginBottom: "70px", padding: '2em 0' }}>
        <Message
          success
          icon="check circle"
          header="Purchase Successful!"
          content="Thank you for your purchase. Your voices will be available in your account shortly."
        />
        <Button primary onClick={() => navigate('/dashBoard')}>
          Return to Dashboard
        </Button>
      </Container>
    );
  }

  if (cartItems.length === 0) {
    return (
      <Container style={{ padding: '2em 0' }}>
        <Segment placeholder>
          <Header icon>
            <Icon name='shopping cart' />
            Your cart is empty
          </Header>
          <Button primary onClick={() => navigate('/dashBoard')}>
            Continue Shopping
          </Button>
        </Segment>
      </Container>
    );
  }

  return (
    <div>
      {/* Header Section */}
      <div className='listContainer' style={{ marginTop: "30px", marginBottom: "20px" }}>
        <Grid>
          <Grid.Row>
            <Grid.Column width={3}>
              <div className="img-with-gradient">
                <Image src={infoTornado} />
              </div>
            </Grid.Column>
            <Grid.Column width={13} textAlign="center">
              <span className="blgListItemTitle">Checkout</span>
              <span className="blgListSubTitle">Complete Your Purchase</span>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </div>

      <Container className='std-pg-content-left' style={{ padding: '1em 0' }}>
        <Grid columns={2} stackable>
          <Grid.Column width={10}>
            <Segment>
              <Header as='h2'>Your Cart</Header>
              <Item.Group divided>
                {cartItems.map(item => (
                  <Item key={item.voiceId}>
                    <Item.Image size='tiny' src={item.imgSrc} />
                    <Item.Content>
                      <Item.Header>{item.voiceName}</Item.Header>
                      <Item.Meta>{item.licenseType} License</Item.Meta>
                      <Item.Description>
                        <p>{item.description}</p>
                      </Item.Description>
                      <Item.Extra>
                        <Button
                          icon
                          color='red'
                          floated='right'
                          onClick={() => handleRemoveItem(item.voiceId)}
                        >
                          <Icon name='trash' /> Remove
                        </Button>
                        <span>${item.price.toFixed(2)}</span>
                      </Item.Extra>
                    </Item.Content>
                  </Item>
                ))}
              </Item.Group>
            </Segment>
          </Grid.Column>

          <Grid.Column width={6}>
            <Segment>
              <Header as='h2'>Order Summary</Header>
              <Grid columns={2}>
                <Grid.Column>
                  <p>Subtotal:</p>
                  <p>Tax:</p>
                  <Divider />
                  <p><strong>Total:</strong></p>
                </Grid.Column>
                <Grid.Column textAlign='right'>
                  <p>${cartTotal.toFixed(2)}</p>
                  <p>${(cartTotal * 0.08).toFixed(2)}</p>
                  <Divider />
                  <p><strong>${(cartTotal * 1.08).toFixed(2)}</strong></p>
                </Grid.Column>
              </Grid>
            </Segment>

            <Segment>
              <Header as='h3'>Payment Method</Header>
              <Form>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '15px', marginBottom: '20px' }}>
                  <Form.Field style={{ margin: 0 }}>
                    <Radio
                      style={{ float: "left" }}
                      label='Credit Card'
                      name='paymentMethod'
                      value='credit-card'
                      checked={paymentMethod === 'credit-card'}
                      onChange={handlePaymentChange}
                    />
                  </Form.Field>
                  <Form.Field style={{ margin: 0, width: "200px" }}>
                    <Radio
                      style={{ float: "left" }}
                      label='PayPal'
                      name='paymentMethod'
                      value='paypal'
                      checked={paymentMethod === 'paypal'}
                      onChange={handlePaymentChange}
                    />
                  </Form.Field>
                  <Form.Field style={{ margin: 0 }}>
                    <Radio
                      style={{ float: "left" }}
                      label='Apple Pay'
                      name='paymentMethod'
                      value='apple-pay'
                      checked={paymentMethod === 'apple-pay'}
                      onChange={handlePaymentChange}
                    />
                  </Form.Field>
                </div>

                <Button
                  fluid
                  primary
                  size='large'
                  onClick={handleCheckout}
                  style={{ marginTop: '1em' }}
                >
                  Complete Purchase
                </Button>
              </Form>
            </Segment>
          </Grid.Column>
        </Grid>
      </Container>
      {AuthStdFooter()}
    </div>
  );
};

export default Checkout;
